import * as React from 'react'
import { Box, Typography} from '@mui/material'
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

export function NavItem({ path, icon, pathname, title }) {

  const navigate = useNavigate()

  let active
  if (pathname == path) active = true
  else active = false 

  // React.useEffect(() => {
  //   let staff = localStorage.getItem("is_staff")
  //   setIsStaff(staff)
  // }, [])

  // React.useEffect(() => {
  //   console.log(staff_only, isStaff)
  //   if(isStaff == 'true') {
  //     setDisplay(true)
  //   } else if (staff_only == true && isStaff == 'false') {
  //     setDisplay(false)
  //   }
  // }, [isStaff])

  const { t } = useTranslation()

  return (
    <li>
      <Box
        {...({ role: 'button' })}
        sx={{
          alignItems: 'center',
          borderRadius: 1.5,
          color: '#64748b',
          cursor: 'pointer',
          display: 'flex',
          flex: '0 0 auto',
          gap: 1,
          p: '10px 16px',
          position: 'relative',
          textDecoration: 'none',
          whiteSpace: 'nowrap',
          transition: 'all 0.2s ease-in-out',
          ...(active && { 
            bgcolor: '#dc3545', 
            color: '#ffffff',
            boxShadow: '0 2px 8px rgba(220, 53, 69, 0.3)',
          }),
          ...(!active && 
            { 
              '&:hover': {
                bgcolor: '#fee2e2',
                color: '#dc3545',
                transform: 'translateX(4px)',
              }
            }
          ),
        }}
        onClick={() => navigate(path)}
      >
        <Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flex: '0 0 auto' }}>
          {icon}
        </Box>
        {/* <Box sx={{ flex: '1 1 auto' }}> */}
          <Typography 
            component="span"
            sx={{ color: 'inherit', fontWeight: 500, paddingY: 0.5 }}
          >
            {t(title)}
          </Typography>
        {/* </Box> */}
      </Box>
    </li>
  )
}